'use strict';
const WebSocketShim = require('../models/websocket-shim'),
	WebSocketShimBufferedSender = require('../models/websocket-shim-buffered-sender'),
	GoldSessionModel = require('../models/gold-session-model'),
	GoldSessionNodeSelectionTracker = require('../models/gold-session-node-selection-tracker'),
	ColorHelper = require('../models/color-helper'),
	mmWidgets = require('../widgets/mm-widgets');
require('../widgets/gold-sessions-sidebar-widget');
module.exports = function goldSessionsStart({navigatorShim, authenticationModel, config, goldApi, mapModel}) {
	if (!navigatorShim || !authenticationModel || !config || !goldApi) {
		throw new Error('invalid-args');
	}
	let sendError = true;
	const webSocketShimUnbuffered = new WebSocketShim({navigatorShim}),
		webSocketShim = new WebSocketShimBufferedSender({webSocketShim: webSocketShimUnbuffered, navigatorShim}),
		colorHelper = new ColorHelper(),
		colors = colorHelper.webColorList(),
		goldSessionModel = new GoldSessionModel({config, webSocketShim, authenticationModel, colors}),
		goldSessionNodeSelectionTracker = new GoldSessionNodeSelectionTracker({goldSessionModel, mapModel, webSocketShim}),
		initialiseWidgets = () => {
			mmWidgets('[data-mm-role~="gold-sessions-list"]').goldSessionsSidebarWidget({goldSessionModel, navigatorShim});
		},
		serialise = (e) => {
			if (e.stack) {
				return e.stack;
			}
			try {
				return JSON.stringify(e);
			} catch (_) {
				return String(e);
			}
		};
	['error', 'protocolError'].forEach(reason => {
		webSocketShim.addEventListener(reason, async (err, context) => {
			if (!sendError) {
				return;
			}
			sendError = false;
			const error = serialise(err),
				userId = await authenticationModel.getUserId();
			try {
				await goldApi.exec('/session/error', {
					reason,
					error,
					userId,
					context
				});
			} catch (e) {
				sendError = true;
				console.error(e);
			}
		});
	});
	return {
		webSocketShim,
		webSocketShimUnbuffered,
		goldSessionModel,
		goldSessionNodeSelectionTracker,
		initialiseWidgets
	};
};

